"use strict";

var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var React = _interopRequireWildcard(require("react"));
var _IconContainer = require("./utils/IconContainer");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var VideoOffFillYes = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var randomId = Math.random().toString(16).substring(2);
  return /*#__PURE__*/React.createElement(_IconContainer.ImpureIconContainer, Object.assign({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("svg", {
    width: '1em',
    height: '1em',
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "icon_VideoOffFillYes_".concat(randomId, "_a"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 16,
    height: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.06 3.819A2.99 2.99 0 0 0 8 3H1.5A1.5 1.5 0 0 0 0 4.5V10c0 1.053.543 1.98 1.364 2.515l8.696-8.696ZM2.36 12.932l8.307-8.307c.213.412.333.88.333 1.375v5.5A1.5 1.5 0 0 1 9.5 13H3c-.22 0-.433-.024-.64-.068ZM12.6 5.55l2.2-1.65a.75.75 0 0 1 1.2.6v7a.75.75 0 0 1-1.2.6l-2.2-1.65a1.5 1.5 0 0 1-.6-1.2v-2.5a1.5 1.5 0 0 1 .6-1.2Z",
    fill: "#000001"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_VideoOffFillYes_".concat(randomId, "_a)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#131619",
    d: "M0 0h16v16H0z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon_VideoOffFillYes_".concat(randomId, "_b"),
    style: {
      maskType: 'alpha'
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.854.146a.5.5 0 0 1 0 .708l-15 15a.5.5 0 0 1-.708-.708l15-15a.5.5 0 0 1 .708 0Z",
    fill: "#F21F31"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_VideoOffFillYes_".concat(randomId, "_b)")
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#F21F31",
    d: "M0 0h16v16H0z"
  }))));
});
var _default = VideoOffFillYes;
exports["default"] = _default;